import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  OnInit, Renderer2, ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { SenderService } from '../../services/sender.service';
import { InterfaceService } from '../../services/interface.service';
import { AllMessengersService } from '../page-start/all-messengers.service';
import { Router } from '@angular/router';
import { LeadsService } from '../../modules/leads/services/leads.service';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'app-page-leads',
  templateUrl: './page-leads.component.html',
  styleUrls: ['./page-leads.component.scss', '../../components/chat-show/messages-scroll/messages-scroll.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class PageLeadsComponent implements OnInit, AfterViewInit {

  constructor(
    public modalService: ModalService,
    public leadsService: LeadsService,
    public allMessengersService: AllMessengersService,
    public interfaceService: InterfaceService,
    public renderer: Renderer2,
    public senderService: SenderService,
    private router: Router,
  ) {
  }
  ngOnInit(): void {

  }
  ngAfterViewInit() {
    if (this.allMessengersService.isAuth) {
      this.interfaceService.setFullSize(this.renderer);
    }else{
      this.interfaceService.setFullSize(this.renderer, false);
    }
  }
  goToTasks() {
    this.router.navigate(['/tasks']);
    this.interfaceService.setFullSize(this.renderer);
  }
}
